import React, { createContext, useContext } from "react";

export const McOpsContext = createContext(null);

export const useMcOps = () => {
  const ctx = useContext(McOpsContext);
  if (!ctx) throw new Error("useMcOps must be used inside McOpsContext.Provider");
  return ctx;
};

/** Deep clone used before every mutation so redux never sees an in-place edit. */
export const clone = (value) =>
  typeof structuredClone === "function"
    ? structuredClone(value)
    : JSON.parse(JSON.stringify(value));
